import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, Button, Phrase, Row } from "@neru/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsReachingLimit } from "./hooks/useIsReachingLimit";
export var ReachLimitAnnouncement = function(param) {
    var onClose = param.onClose;
    var location = useLocation();
    var navigate = useNavigate();
    var isReaching = useIsReachingLimit();
    var handleNavigate = function() {
        onClose && onClose();
        navigate("/plans-and-pricing");
    };
    return isReaching ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "light",
                children: /*#__PURE__*/ _jsx(Badge, {
                    connotation: "warning",
                    icon: "info-line",
                    layout: "soft",
                    shape: "pill",
                    children: "Usage limits reached"
                })
            }),
            /*#__PURE__*/ _jsx(Phrase, {
                className: "mt-4",
                children: "Your app may stop working soon due to limits in your current plan. Upgrade your plan to prevent any potential issues."
            }),
            location.pathname !== "/plans-and-pricing" && /*#__PURE__*/ _jsx(Row, {
                className: "mt-4 dark",
                children: /*#__PURE__*/ _jsx(Button, {
                    label: "Upgrade your plan",
                    layout: "outlined",
                    onClick: handleNavigate
                })
            })
        ]
    }) : null;
};

//# sourceMappingURL=ReachLimitAnnouncement.js.map